<template lang="pug">
.reservation-message-modal
  b-modal(v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    template(#modal-header="{ cancel }")
      .title(style="font-size: 20px;")
        span {{ _titleBeforeWeek }}
        span(:class="_weekCssClass") {{ _titleWeek }}
        span {{ _titleAfterWeek }}
      button.close(type="button" @click="cancel") ×

    span 件数：{{ items.length }}件
    NeedsMealModalTable(v-model="items" :fields="fields" @onOoutingDetail="onOoutingDetail")

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import NeedsMealModalTable, { MealType, NeedsMealModalTableField, NeedsMealModalTableItem } from "@/pc/containers/outings/NeedsMealModalTable.vue";
import { PcUrl } from "@/commons/constants/PcUrl";

/**
 * ### 食事キャンセル一覧（日付、食事指定）モーダル
 */
@Component({
  components: {
    NeedsMealModalTable
  }
})
export default class NeedsMealModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** 食事種別 */
  @Prop()
  mealType!: MealType;
  /** 日付 */
  @Prop()
  datetime!: number;
  /** 行情報 */
  @Prop()
  items!: Array<NeedsMealModalTableItem>;

  /** 列名 */
  fields: Array<NeedsMealModalTableField> = [];

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _titleBeforeWeek(): string {
    if (!this.datetime) {
      return "";
    }
    const datetime: string = this.$dateUtil.convertNumberToString(this.datetime, "yyyy年mm月dd日");
    return `${datetime}（`;
  }

  get _titleWeek(): string {
    if (!this.datetime) {
      return "";
    }
    const dateObject: Date = this.$dateUtil.convertNumberToDate(this.datetime);
    const week: string = this.$dateUtil.getWeekName(dateObject, "ja");
    return `${week}`;
  }

  /**
   * ### 曜日の文字色CssClassの割り当て
   */
  get _weekCssClass(): string {
    let weekClassName: string = "";
    const dateObject: Date = this.$dateUtil.convertNumberToDate(this.datetime);
    const week: string = this.$dateUtil.getWeekName(dateObject, "ja");
    switch (week) {
      case "日":
        weekClassName = "sunday";
        break;
      case "土":
        weekClassName = "saturday";
        break;
      default:
        break;
    }
    return weekClassName;
  }

  get _titleAfterWeek(): string {
    if (!this.mealType) {
      return "";
    }
    return `） ${this.convertMealTypeName(this.mealType)} キャンセル一覧`;
  }

  public convertMealTypeName(mealType: MealType): string {
    switch (mealType) {
      case MealType.BREAKFAST: {
        return "朝食";
      }
      case MealType.LUNCH: {
        return "昼食";
      }
      case MealType.SNACK: {
        return "おやつ";
      }
      case MealType.DINNER: {
        return "夕食";
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    const fields: Array<NeedsMealModalTableField> = this.createFields();
    this.fields = fields;
    return;
  }

  /**
   * ### 列を作成する
   */
  public createFields(): Array<NeedsMealModalTableField> {
    const fields: Array<NeedsMealModalTableField> = [];
    fields.push({ key: "residentGroup", label: "利用者グループ", sortable: false, sortDirection: "desc", class: "resident-group" });
    fields.push({ key: "resident", label: "利用者名（部屋名）", sortable: false, sortDirection: "desc", class: "resident" });
    fields.push({ key: "control", label: "届出内容", sortable: false, sortDirection: "desc", class: "control text-center" });
    return fields;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }

  /**
   * ### 届出内容 詳細ボタン押下イベント処理
   */
  public onOoutingDetail(item: NeedsMealModalTableItem): void {
    this.$router.push({ name: PcUrl.OutingDetail, params: { id: `${item.id}` } });
    return;
  }
}
</script>
